import moment from "moment";
import Locale from "@/helper/locale/locale.js";

export default {
    /********* Datetime *********
     * @function convertDateToTimeStampUnix
     * @function getDayInMonth
     * @function isDatetimeValid
     ****************************/
    convertDateToTimeStampUnix: function(date) {
        var unixTime = (date.getTime() - date.getTimezoneOffset() * 60 * 1000) / 1000;
        return unixTime;
    },
    dateIsoFormat: function(date) {
        return moment(date).format('YYYY-MM-DD');
    },
    convertTimeStampUnixToDate: function (timestamp) {
        let date = new Date(timestamp * 1000);
        return date;
    },
    getDaysInMonth: function (date) {
        const month = date.getMonth();
        const year = date.getYear();
        const d = date.getDate();

        return new Date(year, month + 1, d).getDate();
    },
    isDatetimeValid: function(y, m, d) {
        var year = y;
        var month = m < 10 ? '0' + m : m;
        var day = d < 10 ? '0' + d : d;
        var dateFormat = year + '-' + month + '-' + day;

        return moment(dateFormat).isValid();
    },
    getEndOfMonth: function(year, month) {
        month = parseInt(month) < 10 ? '0' + month : month;
        var yearMonth = `${year}-${month}-01`;
        var lastDayStr = moment(yearMonth, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD');
        return new Date(lastDayStr);
    },
    getEndOfCurrentMonth: function() {
        var d = new Date();
        var y = d.getFullYear();
        var m = d.getMonth() + 1;
        var date = this.getEndOfMonth(y, m);
        return date.getDate();
    },
    /********** Date Format ***********
     * @function dateFullFormat
     * @function getYearByLocale
     * @function timeFormat
     **********************************/
    dateFullFormat: function(timestamp) {
        if (Locale.getLocaleCode() == 1033) {
            moment.locale('en');
        } else {
            moment.locale('th');
        }
        var strDate = moment.unix(timestamp).utc().format('DD MMMM ');
        var year = moment.unix(timestamp).utc().format('YYYY');
        year = this.getYearByLocale(year);

        return strDate + year;
    },
    getYearByLocale: function(year) {
        if (Locale.getLocaleCode() == 1033) {
            return year;
        }
        return parseInt(year) + 543;
    },
    timeFormat: function(timestamp) {
        var strDate = moment.unix(timestamp).utc().format('HH:mm:ss');
        return strDate;
    }
}
